import { differenceInHours, isAfter } from 'date-fns';
import { IconNameT, MIME_TYPES } from '@cad-arc';
import { UserExport } from '@mark43/cad-api';

export function getIconForExport(exportItem: UserExport): IconNameT {
    if (exportItem.failedPrint) {
        return 'Alert';
    } else if (exportItem.file === undefined) {
        return 'Document';
    } else if (exportItem.file.fileType === 'ZIP') {
        return 'DocumentZip';
    } else if(exportItem.file.fileCategory === 'PDF') {
        return 'PDFDocument';
    } else if(exportItem.file.fileCategory === 'IMAGE') {
        return 'Image';
    } else {
        return 'Document';
    }
}

export function getExportFileType(exportItem: UserExport): string {
    if (exportItem.file === undefined) {
        return MIME_TYPES.txt;
    }

    switch (exportItem?.file?.fileCategory) {
        case 'PDF':
            return MIME_TYPES.pdf;
        case 'IMAGE':
            return MIME_TYPES.png;
        default:
            return MIME_TYPES.zip;
    }
}

export function getExportExpiration(exportItem: UserExport): string {
    if (exportItem.expirationDate === undefined) {
        return '';
    }

    const dateWhenExpired = new Date(exportItem.expirationDate);

    if (isAfter(new Date(), dateWhenExpired)) {
        return 'Expired';
    }
    const hoursTilExpiration = Math.min(differenceInHours(new Date(exportItem.expirationDate), new Date()), 11);

    return `Expires in ${hoursTilExpiration} ${
        hoursTilExpiration === 1 ? 'hour' : 'hours'
    }`;
}
